<template>
    <div class="todo-app">
        <h1>TODOS</h1>

        <div class="add-todo">

            <v-text-field
                label="Main Input"
                v-model="todoInput"
            />

            <v-btn
                @click="addTodo"
                elevation="2"
            >
                Add!
            </v-btn>
        </div>

        <div class="todos">
            <div v-for="todo in todos" :key="todo.id">
                <div class="todo">
                    <h3>{{todo.title}}</h3>

                    <v-btn
                        @click="removeTodo(todo)"
                        elevation="2"
                    >
                        Delete
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '../scss/TodoApp.scss';

export default {
    name: 'TodoApp',

    data() {
        return {
            todos: this.$store.state.todos,
            
            todoInput: ''
        }
    },

    methods: {
        addTodo() {
            if (this.todoInput === '' || !this.todoInput) return;
            this.$store.commit('addTodo', this.todoInput);
        },

        removeTodo(todo) {
            const index = this.todos.findIndex(obj => obj.id === todo.id);
            this.$store.commit('removeTodo', index);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/TodoApp.vue